export const getDropTargetElementsAtPoint = (x, y, dropTargets) =>
  dropTargets.filter(t => {
    const { left, right, top, bottom } = t.getBoundingClientRect();
    return x >= left && x <= right && y <= bottom && y >= top;
  });



// WEBPACK FOOTER //
// ./src/helpers/dragNDrop.js